<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>One More Step: Verify Your Email</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <!-- Before a resend is requested: explain, name the address, say where to look. -->
  <ng-container *ngIf="!resendSent">
    <p class="mt-3">{{ message }}</p>

    <p *ngIf="email">
      A new verification link can be sent to <b>{{ email }}</b>.
    </p>

    <p class="text-muted">
      Check your spam or junk folder if you cannot find the email. Once you have opened the link in that
      email, come back here and sign in.
    </p>
  </ng-container>

  <!-- After a resend: confirm, and say what to do next. -->
  <ng-container *ngIf="resendSent">
    <p class="mt-3">
      <b>Verification email sent.</b>
    </p>

    <p *ngIf="email">
      We have sent a new verification link to <b>{{ email }}</b>.
    </p>

    <p class="text-muted">
      Open the link in that email to verify your address, then come back here and sign in. Check your
      spam or junk folder if you cannot find it.
    </p>
  </ng-container>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-center my-2 py-2">
  <div class="p-2" *ngIf="!resendSent">
    <button
      type="button"
      mat-raised-button
      color="primary"
      [disabled]="inProgress"
      (click)="onResend()">
      <mat-icon>send</mat-icon>
      {{ inProgress ? 'Sending...' : 'Resend Verification Email' }}
    </button>
  </div>

  <div class="p-2">
    <button type="button" mat-raised-button color="secondary" (click)="onClose()">
      <mat-icon>close</mat-icon> Close
    </button>
  </div>
</mat-dialog-actions>
